// extracted by css-extract-rspack-plugin
export default {"cls1":"PullToRefresh-cls1_-ng","cls2":"PullToRefresh-cls2_dq1 PullToRefresh-cls1_-ng"};